// Generated by CoffeeScript 1.12.7
var _, employeeRoles, roles, wildcard;

_ = require('lodash');

wildcard = require('wildcard');

module.exports = employeeRoles = {};


/*
Permission syntax:
'*' grants all actions
'timeclock.*' grants permission do any action prefixed with `timeclock.`
'timeclock.manage' grants permission for just that one action.

Note, you should only create permissions for actions that should be restricted
to a select group of roles. You should not create permissions for actions granted to
everybody.
 */

roles = {
  ops_associate: {
    title: 'Ops Associate',
    description: 'No access to restricted features. (Deprecated: don\'t use this permission!)',
    permissions: ['inventory.prep', 'inventory.stow', 'inventory.count', 'pick.*', 'ship.*'],
    needsPin: false
  },
  picker: {
    title: 'Ops Associate - Pick',
    description: 'Access to pick & sort apps.',
    permissions: ['pick.*', 'ship.getNextSortDirective', 'ship.sort', 'ship.markSortRackFull', 'employees.read', 'devices.update', 'inventory.read'],
    needsPin: false
  },
  shipper: {
    title: 'Ops Associate - Ship',
    description: 'Access to the ship app.',
    permissions: ['ship.*'],
    needsPin: false
  },
  driver: {
    title: 'Ops Associate - Driver',
    description: 'Access to the drive app.',
    permissions: [],
    needsPin: false
  },
  dispatcher: {
    title: 'Dispatcher',
    description: 'Access to managerial roles in Drive',
    permissions: ['drive.*'],
    needsPin: false
  },
  inventory_associate: {
    title: 'Ops Associate - Inventory',
    description: 'Access to the inventory, stow, prep, cycle count, pick triage, and receiving apps.',
    permissions: ['inventory.*', 'triage.getProductList', 'employees.read', 'devices.update', 'capacities.read', 'purchase_orders.receive'],
    needsPin: false
  },
  ops_manager: {
    title: 'Ops Manager',
    description: 'Access to all restricted features in all apps.',
    permissions: ['employees.*', 'inventory.*', 'drive.*', 'triage.*', 'availability.diagnose', 'devices.*', 'capacities.*', 'catalog.*', 'purchase_orders.*', 'producer_packages.update', 'pick.*', 'ship.*'],
    needsPin: true
  },
  supervisor: {
    title: 'Supervisor',
    description: 'Read access to employees app and manager pin',
    permissions: ['employees.read'],
    needsPin: true
  },
  purchaser: {
    title: 'Purchaser',
    description: 'Access to all restricted features in the Catalog and Purchase Orders apps.',
    permissions: ['catalog.*', 'purchase_orders.*', 'availability.diagnose', 'capacities.read'],
    needsPin: false
  },
  foodmaker: {
    title: 'Foodmaker',
    description: 'Access to all restricted features in the Catalog, Purchase Orders, and Merchandising apps.',
    permissions: ['catalog.*', 'purchase_orders.*', 'availability.diagnose', 'merchandising.*', 'capacities.read'],
    needsPin: true
  },
  inventory_control: {
    title: 'Inventory Control Specialist',
    description: 'Access to all restricted features in the Inventory, Pick Triage, and Receiving apps.',
    permissions: ['inventory.*', 'availability.diagnose', 'triage.*', 'employees.read', 'devices.update', 'capacities.read', 'purchase_orders.receive'],
    needsPin: false
  },
  eng: {
    title: 'Engineer',
    description: 'Access to all restricted features.',
    permissions: ['*'],
    needsPin: true
  }
};


/*
list of all available roles
 */

employeeRoles.roles = Object.keys(roles);


/*
mapping of role : permissions.
 */

employeeRoles.permissions = employeeRoles.roles.reduce(function(permissions, role) {
  permissions[role] = roles[role].permissions;
  return permissions;
}, {});


/*
mapping of role : description.
 */

employeeRoles.descriptions = employeeRoles.roles.reduce(function(permissions, role) {
  permissions[role] = roles[role].description;
  return permissions;
}, {});


/*
mapping of role : title.
 */

employeeRoles.titles = employeeRoles.roles.reduce(function(permissions, role) {
  permissions[role] = roles[role].title;
  return permissions;
}, {});


/*
usage:
@param userRoles (array). any role with permission grants.
@param action (string) to check if user has permission for.
  - `true` trumps `false`; any grant is accepted.
@return boolean.

to check if user has multiple permissions, call multiple times.
 */

employeeRoles.can = function(userRoles, action) {
  var i, j, len, len1, permission, permissions, ref, role;
  permissions = employeeRoles.permissions;
  for (i = 0, len = userRoles.length; i < len; i++) {
    role = userRoles[i];
    if (permissions[role] != null) {
      ref = permissions[role];
      for (j = 0, len1 = ref.length; j < len1; j++) {
        permission = ref[j];
        if (wildcard(permission, action)) {
          return true;
        }
      }
    }
  }
  return false;
};

employeeRoles.needsPin = function(userRoles) {
  return _.some(userRoles, function(userRole) {
    return roles[userRole].needsPin;
  });
};
